import { PrinterPosPlayOutlineIcon } from './PrinterPosPlayOutlineIcon';

/**
 * author: Colton Wiscombe
 * id C725674B-6092-43B7-9F0D-D878910CE943
 * name printer-pos-play-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-play-outline.svg
 * tags
 * - Printer 
 */
export const PrinterReceiptPlayOutlineIcon = PrinterPosPlayOutlineIcon;
export default PrinterReceiptPlayOutlineIcon